module.exports = __webpack_public_path__ + "img/star-bg.bf673743.png";